import { Navigate, useParams } from "react-router-dom"
import { useAuth } from "@/hooks/useAuth"
import useCurrentUser from "@/hooks/use-current-user"
import { hasPermission } from "@/lib/admin-permissions"

export default function AdminCreateRouteGuard({ children }: { children: React.ReactNode }) {
  const { councilId } = useParams()
  const scopedCouncilId = councilId ? Number(councilId) : undefined
  const { user } = useAuth()
  const { hasRole } = useCurrentUser()
  const canCreateAdmin =
    hasRole("super_admin") ||
    hasPermission(user?.permissions, "admin_management", "write_all", scopedCouncilId)

  if (!canCreateAdmin) {
    return (
      <Navigate
        to={scopedCouncilId ? `/council/${scopedCouncilId}/manage-admin` : "/manage-admin"}
        replace
      />
    )
  }

  return <>{children}</>
}
